"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusMember = void 0;
const index_1 = require("../index");
const IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
class BusMember {
    //orgURL= data.cst_url_code_dn
    constructor(data, desc) {
        this.identityInfo = IdentityInfo_1.default.genFromList(null, data, [
            "OBJECTID",
            "State",
            "CD113FP",
            null,
            "sldl",
            "sldu",
        ]);
        this.address = index_1.parseEsriString(`${data?.Address}, ${data?.City} ${data?.Abbrev} ${data?.Zip}`);
        this.sectionTitle = index_1.parseEsriString(data?.Tier);
        this.orgName = index_1.parseEsriString(data.Company_Na);
        if (desc) {
            this.orgDescription = index_1.parseEsriString(data.Descript);
        }
        else {
            this.orgDescription = null;
        }
    }
}
exports.BusMember = BusMember;
